type ActionDelays = {
  [delay: string]: () => void;
  init: () => void;
};

export class Sequence {
  constructor(actions: ActionDelays) {
    this.executeActions(actions);
  }

  executeActions(actions: ActionDelays): void {
    for (const delay of Object.keys(actions)) {
      setTimeout(
        // Fixed noUncheckedIndexedAccess NIM-19408
        actions[delay]!,
        delay === 'init' ? 0 : Number.parseInt(delay, 10),
      );
    }
  }
}
